import { format, parseISO } from "date-fns";
import { attendanceAlertType } from "./AttendanceAlertModal";

type Attendance = {
  id: number;
  classId: number;
  date: string; // yyyy-MM-dd
};

type Class = {
  id: number;
  name: string;
  teacherId: number;
};

type Teacher = {
  id: number;
  userName: string;
};

/**
 * Hàm kiểm tra điểm danh bị trùng trong cùng ngày
 * Trả về mảng đối tượng: mỗi giáo viên có danh sách lớp và ngày bị trùng điểm danh
 */
export const checkDuplicatingAttendance = (
  attendanceSessions: Attendance[],
  classes: Class[],
  teachers: Teacher[]
): {
  teacherName: string;
  messages: string[];
  attendanceAlertType: string;
}[] => {
    // 🕒 Tính mốc 7 ngày trước
  const today = new Date();
  const sevenDaysAgo = new Date();
  sevenDaysAgo.setDate(today.getDate() - 7);

  // 📅 Chỉ giữ các bản ghi trong 7 ngày gần đây
  const recentSessions = attendanceSessions.filter((att) => {
    const attDate = parseISO(att.date);
    return attDate >= sevenDaysAgo && attDate <= today;
  });
  // Nhóm attendance theo classId + date
  const attendanceMap: { [key: string]: Attendance[] } = {};

  recentSessions.forEach((att) => {
    const key = `${att.classId}_${att.date}`;
    if (!attendanceMap[key]) {
      attendanceMap[key] = [];
    }
    attendanceMap[key].push(att);
  });

  // Tìm các class/date có nhiều hơn 1 bản ghi => bị trùng
  const duplicateRecords = Object.entries(attendanceMap)
    .filter(([_, records]) => records.length > 1)
    .map(([key]) => {
      const [classId, date] = key.split("_");
      const classItem = classes.find((c) => c.id === parseInt(classId, 10));

      return {
        teacherId: classItem?.teacherId ?? 0,
        className: classItem?.name ?? "Unknown class",
        date: format(parseISO(date), "dd/MM/yyyy"),
      };
    });

  // Gom các bản trùng theo giáo viên
  const alerts: { [key: number]: string[] } = {};
  duplicateRecords.forEach((item) => {
    if (!alerts[item.teacherId]) {
      alerts[item.teacherId] = [];
    }
    alerts[item.teacherId].push(`Lớp ${item.className}, ngày ${item.date}`);
  });

  // Trả về mảng { teacherName, messages[] }
  return Object.entries(alerts).map(([teacherId, messages]) => {
    const teacher = teachers.find((t) => t.id === parseInt(teacherId, 10));
    return {
      teacherName: teacher?.userName || "Unknown",
      messages,
      attendanceAlertType: attendanceAlertType.DUPLICATING
    };
  });
};
